<template>
  <div class="l-recorder-container">
    <!-- 置灰：disabled   默认：default   录音中：recording -->
    <div
      ref="barparent"
      class="btn-recorder"
      @click="handleRecordBtnClick"
      :class="{
        disabled: status === RecordBtnStatus.DISABLE || disabled,
        default: status === RecordBtnStatus.INITIAL,
        recording: status === RecordBtnStatus.RECORDING,
      }"
    >
      <span class="text">{{ buttonText }}</span>
      <!-- 进度条 -->
      <ProcessApp
        v-if="status === RecordBtnStatus.RECORDING"
        :total-time="options.duration"
      />
    </div>
  </div>
</template>

<script>
import { recordPrepare, recordEnd, recordBreak, recordCancel } from '@/utils/bridge'
import { recordResult } from './src/tool/util'
import { RecordBtnStatus, RecordTimeMin } from './src/tool/const'
import ProcessApp from "./src/components/process-app.vue"
import { resetScore, getMode } from './src/tool/util'
import { isOldMiPad } from './src/tool/helper'

export default {
  components: { ProcessApp },
  props: {
    /**
     * 参数 options：
     *  elementType  元素类型（例如：821）
     *  duration     最长录音时长
     *  keywords     中心词
     *  text         标准答案文本
     *  audioFileName     音频文件命名
     */
    options: {
      type: Object,
      default: function () {
        return null
      },
    },
    /**
     * 是否可点击
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * 允许手动停止录音 默认false
     */
    allowManual: {
      type: Boolean,
      default: false,
    },
    btnText: [String],
    /**
     *
     * event
     *  @start
     *  @stop
     *  @result
     *
     * function
     *  checkPermission
     */
  },
  data() {
    return {
      RecordBtnStatus,
      mode: "",
      status: RecordBtnStatus.INITIAL,
      hasRecorder: false, // 是否初始化录音功能
      //  ['点击按钮回答问题', '点击提交录音', '录音中'],
      btnDefaultTxt: "点击按钮回答问题",
      currentTime: 0, // 当前时间点
      isRecordBtnLoading: false, // 录音按钮是否可点击
    }
  },
  computed: {
    buttonText() {
      return [
        this.btnText || this.btnDefaultTxt,
        this.btnText || this.btnDefaultTxt,
        "录音中...",
        "录音完成",
      ][this.status]
    },
  },
  mounted() {
    this.bindToWindow()
  },
  destroyed() {
    recordBreak()
    clearTimeout(this.stopRecordTimer)
    this.$lLoading.show()
  },
  methods: {
    bindToWindow() {
      recordCancel(() => {
        window.location.reload()
      })
    },
    handleRecordBtnClick() {
      if (this.isRecordBtnLoading) return
      this.isRecordBtnLoading = true
      
      // 已经录音，且不允许手动停止
      if (this.hasRecorder && !this.allowManual) {
        // 正在录音
        return
      }

      // 手动停止
      if (this.hasRecorder && this.allowManual) {
        this.stopRecord()
        return
      }

      if (isOldMiPad()) {
        this._setStart()
      }
      this.mode = getMode(this.options.elementType)
      const recorderData = JSON.stringify({
        mode: this.mode,
        text: this.options.text,
        ScoreCoeff: 3.5, // 严苛度 1-4
        audioFileName: this.options.audioFileName,
      })
      recordPrepare(recorderData, (res) => {
        const resVal = JSON.parse(res)
        resVal.status ? this.recordingSuccess() : this.recordingFailure(resVal.data)
      })
    },
    recordingSuccess() {
        this._setStart()
        this.hasRecorder = true
        // 初始化完成
        this.isRecordBtnLoading = false
        this.recordConuntDown()
    },
    recordConuntDown() {
        // TODO: 等待视频加载完成后再开始录音
        this.stopRecordTimer = setTimeout(() => {
          this.stopRecord()
        }, this.options.duration * 1000)

        setTimeout(() => {
          this.currentTime = 3
        }, RecordTimeMin * 1000)
    },
    stopRecord() {
      // 录音不能小于3秒
      if (this.currentTime < RecordTimeMin) {
        this.$lToast("当前录音时间太短请继续录音～")
        this.isRecordBtnLoading = false
        return
      }
      clearTimeout(this.stopRecordTimer)
      this.$lLoading.show()
      this.reset()
      this._setStop()
      
      recordEnd((res) => {
        this.$lLoading.hide()
        const { status, data } = JSON.parse(res)
        if (!status) {
          // 如果录音结果返回失败，则刷新页面，native会弹toast提示
          this.$lToast(data)
          setTimeout(() => {
            window.location.reload()
          }, 2000)
          return
        }
        const recordData = recordResult(this.mode, this.options.text, JSON.parse(data))
        recordData.suggestedScore = resetScore(this.options.keywords, this.mode, recordData)
        recordBreak()
        this.$emit("result", recordData)
      })
    },
    recordingFailure(errData) {
        this.isRecordBtnLoading = false
        if (errData) this.reset()
    },
    reset() {
      this.currentTime = 0
      this.status = RecordBtnStatus.INITIAL
      this.hasRecorder = false
    },
    _setStart() {
      this.status = RecordBtnStatus.RECORDING
      this.$emit("start")
    },
    _setStop() {
      this.status = RecordBtnStatus.DISABLE
      this.isRecordBtnLoading = false
    },
  },
}
</script>

<style lang="stylus">
@import './index.styl'
</style>
